import { useEffect, useRef } from 'react';
import { api } from '../api';
import { getDeviceMeta } from '../utils/device';

const PING_MS = 60000;

export function useSessionLimitMonitor(token, logout, onBlocked) {
  const blockedRef = useRef(false);

  useEffect(() => {
    if (!token) return undefined;
    blockedRef.current = false;

    let active = true;
    const ping = async () => {
      try {
        const res = await api.sessionPing(token, getDeviceMeta());
        if (!active || blockedRef.current) return;
        if (res?.blocked) {
          blockedRef.current = true;
          onBlocked?.(res);
          logout();
        }
      } catch {
        /* ignore network errors */
      }
    };

    ping();
    const id = window.setInterval(ping, PING_MS);
    return () => {
      active = false;
      window.clearInterval(id);
    };
  }, [token, logout, onBlocked]);
}
